var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8190_18479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 47.375C22.8921 47.375 26.25 44.0171 26.25 39.875C26.25 35.7329 22.8921 32.375 18.75 32.375C14.6079 32.375 11.25 35.7329 11.25 39.875C11.25 44.0171 14.6079 47.375 18.75 47.375Z",
    fill: "#F15927",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23C22.8921 23 26.25 19.6421 26.25 15.5C26.25 11.3579 22.8921 8 18.75 8C14.6079 8 11.25 11.3579 11.25 15.5C11.25 19.6421 14.6079 23 18.75 23Z",
    fill: "#F15927",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 47.375C45.3921 47.375 48.75 44.0171 48.75 39.875C48.75 35.7329 45.3921 32.375 41.25 32.375C37.1079 32.375 33.75 35.7329 33.75 39.875C33.75 44.0171 37.1079 47.375 41.25 47.375Z",
    fill: "#F15927",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 53C8.80988 51.2535 10.5084 49.8359 12.4611 48.8596C14.4137 47.8833 16.5669 47.375 18.75 47.375C20.9331 47.375 23.0863 47.8833 25.0389 48.8596C26.9916 49.8359 28.6901 51.2535 30 53C31.3099 51.2535 33.0084 49.8359 34.9611 48.8596C36.9137 47.8833 39.0669 47.375 41.25 47.375C43.4331 47.375 45.5863 47.8833 47.5389 48.8596C49.4916 49.8359 51.1901 51.2535 52.5 53",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.25 23C45.3921 23 48.75 19.6421 48.75 15.5C48.75 11.3579 45.3921 8 41.25 8C37.1079 8 33.75 11.3579 33.75 15.5C33.75 19.6421 37.1079 23 41.25 23Z",
    fill: "#F15927",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 28.625C8.80988 26.8785 10.5084 25.4609 12.4611 24.4846C14.4137 23.5083 16.5669 23 18.75 23C20.9331 23 23.0863 23.5083 25.0389 24.4846C26.9916 25.4609 28.6901 26.8785 30 28.625C31.3099 26.8785 33.0084 25.4609 34.9611 24.4846C36.9137 23.5083 39.0669 23 41.25 23C43.4331 23 45.5863 23.5083 47.5389 24.4846C49.4916 25.4609 51.1901 26.8785 52.5 28.625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8190_18479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersFour);
export default __webpack_public_path__ + "static/media/UsersFour.b464b7eb83fe27d2bd52df86472551b3.svg";
export { ForwardRef as ReactComponent };